<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141.7 141.7" style="enable-background:new 0 0 141.7 141.7" xml:space="preserve">
    <circle class="st0" cx="70.8" cy="71.3" r="40.7"/>
    <path class="st1" d="M64.2 98.1h10.4V72H82l.8-8.8h-8.1v-5c0-2.1.4-2.9 2.4-2.9h5.7v-9.1h-7.2c-7.8 0-11.3 3.4-11.3 10v7h-5.4v8.9h5.4v26z"/>
  </svg>
</template>
